import React, {FC} from "react"

import {Body} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage from "@irati/utils/lang"
import {ReportingCompanyBenefit} from "@irati/types"

import {Tooltip} from "@irati/ui/src/Tooltip"
import {Position, ImageWrapper, Image, Wrapper} from "../styled"
import getRankingColor from "../getRankingColor"

interface Props {
  benefit: ReportingCompanyBenefit
  ranking: number
}

const TopBenefit: FC<Props> = ({benefit, ranking}) => {
  const theme = useTheme()

  if (benefit?.companyBenefit) {
    return (
      <Tooltip tooltipChildren={benefit.companyBenefit?.header}>
        <div>
          <Wrapper size={50}>
            <Position size={22} left="-10px" justifyContent="center" alignItems="center" bgColor={getRankingColor(ranking, theme)}>
              <Body color={theme.colors.greys.white}>#{ranking}</Body>
            </Position>
            <ImageWrapper size={50}>
              <Image src={benefit.companyBenefit.cardImage} height="50px" alt="" />
            </ImageWrapper>
          </Wrapper>
          <Body small textAlign="center">
            <FormattedMessage
              id="admin.components.dashboard.reporting.companyBenefits.topBenefit.clicks"
              values={{redemptions: benefit.redemptions}}
            />
          </Body>
        </div>
      </Tooltip>
    )
  }
  return null
}

export default TopBenefit
